import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Logo } from '.';
import { ThemeSettings } from '../../theme';

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    background: linear-gradient(${ThemeSettings.colors.background}60, ${ThemeSettings.colors.background}60), url(/img/paper_tiler.png), ${ThemeSettings.colors.background};
    min-height: 100vh;

    & img {
        width: 300px;
    }

    & .MuiPaper-root {
      background: transparent;
    }

`;

export const PublicPageWrapper = (props: { children?: ReactNode }) => {
    return <Wrapper>
        <Logo version={2} />
        {props.children}
    </Wrapper>
}
